// extracted by mini-css-extract-plugin
export default {"form":"Form_form__JJKDN","section":"Form_section__T4fcp","wrapper":"Form_wrapper__SX3B9","group":"Form_group__tMLsZ"};